import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useTokenStore from '@store/token-store/token.store.ts';
import { RoutePaths } from '@utils/route.utils.ts';

interface Props {
  children: React.ReactNode;
}

const AuthGuard: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate();
  const { accessToken, clearTokens } = useTokenStore();

  useEffect(() => {
    if (!accessToken) {
      clearTokens();
      navigate(RoutePaths.Auth.SignIn.absolutePath, { replace: true });
    }
  }, [accessToken, clearTokens, navigate]);

  if (!accessToken) return null;

  return <>{children}</>;
};

export default AuthGuard;
